import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { useContractStatuses } from '../../hooks';
import type { ContractStatus } from '../../models';

export interface ContractStatusFieldProps extends Omit<SelectProps<ContractStatus>, 'options'> {
  label?: string;
  errorMessage?: SelectFieldProps<ContractStatus>['errorMessage'];
  isInvalid?: boolean;
}

export const ContractStatusField: React.FC<ContractStatusFieldProps> = ({ label, ...otherFieldProps }) => {
  const { data, isLoading, setSearch } = useContractStatuses();

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={setSearch}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={setSearch}
      isLoading={isLoading}
    />
  );
};
